export default __webpack_public_path__ + "static/media/SuperStinky3.bf196278.gif";